import { useMutation } from '@apollo/client';
import { useCallback } from 'react';

import { SavePatientChoicesDocument } from '../graphql/generated/graphql';

const OURA_IMPRESSION_CHOICE_KEY = 'fall26OuraCampaignImpression';

/**
 * MYPT-963 STOPGAP -- READ BEFORE TOUCHING.
 *
 * No dedicated impression mutation exists in prescryptive-graph yet, and
 * building one was out of scope for the campaign deadline.
 *
 * Mutation records "this prescription's promo was seen, most recently with this
 * identifier" rather than a true per-view impression log.
 * TODO: Replace this hook's body with a real impression mutation when exists;
 */
export const useRecordOuraImpression = (): ((
    prescriberOrderId: string
) => Promise<void>) => {
    const [savePatientChoices] = useMutation(SavePatientChoicesDocument);

    return useCallback(
        async (prescriberOrderId: string): Promise<void> => {
            await savePatientChoices({
                variables: {
                    prescriberOrderId,
                    choices: [
                        {
                            patientChoiceKey: OURA_IMPRESSION_CHOICE_KEY,
                            patientChoiceValue: 'true',
                        },
                    ],
                },
            });
        },
        [savePatientChoices]
    );
};
